export default __webpack_public_path__ + "static/media/profile.520e9ea0.svg";